var module = angular.module('octopusApp.library');

module.controller('LifecycleAddEnvironmentDialogController', function($scope, busy, $uibModalInstance, environments) {
  var isLoading = $scope.isLoading = busy.create();

  $scope.users = null;
  $scope.adding = { environmentId: '', trigger: 'Manual' };
  $scope.environments = environments;

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.save = function () {
    $uibModalInstance.close($scope.adding);
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/lifecycles/controllers/lifecycle_add_environment_dialog_controller.js
// module id = 448
// module chunks = 1